module.exports = __webpack_public_path__ + "media/icons/user-67b67297.svg";